/* eslint-disable filename-rules/match */
import { t } from "i18n/i18n";
import { GearSettingsIcon, PersonSingleIcon, PersonSingleStarIcon, StarIcon } from "mds/icons";
import { HomeRole } from "utils/urls";

export const roleLabel: Record<HomeRole, string> = {
  [HomeRole.STUDENT]: t("home.role.student"),
  [HomeRole.INSTRUCTOR]: t("home.role.instructor"),
  [HomeRole.ADMIN]: t("home.role.admin"),
  [HomeRole.SECTION_ASSISTANT]: t("home.role.section_assistant"),
};

export const roleIcon: Record<HomeRole, React.ReactNode> = {
  [HomeRole.STUDENT]: <PersonSingleIcon />,
  [HomeRole.INSTRUCTOR]: <StarIcon />,
  [HomeRole.SECTION_ASSISTANT]: <PersonSingleStarIcon />,
  [HomeRole.ADMIN]: <GearSettingsIcon />,
};
